import { LIST_VIEW, MAP_VIEW } from "./types";

export const toggleMap = () => async (dispatch) => {
  dispatch({ type: MAP_VIEW });
};

export const toggleList = () => async (dispatch) => {
  dispatch({ type: LIST_VIEW });
};
